import * as React from 'react';
import './entranceFeeSummary.module.scss';
import { EntranceFeeShowView } from '../../../types/entranceFees';
import { SummaryBody, SummaryHeader, SummaryPriceRow, SummarySplitter, SummarySubPriceRow } from './base';

type Props = {
  entranceFee: EntranceFeeShowView;
  installments: number;
  title?: string;
};

export class EntranceFeeSummary extends React.Component<Props> {
  render() {
    const { entranceFee, installments, title = '入会金' } = this.props;
    const option = entranceFee.options.find((o) => o.installments === installments);
    return (
      <div styleName="entrance-fee-summary">
        <SummaryHeader>{title}</SummaryHeader>
        <SummaryBody>
          <SummarySubPriceRow label="金額" price={entranceFee.price} unit={'円（税別）'} />
          {entranceFee.discount_campaigns.map((d) => {
            return (
              d.discount > 0 && (
                <SummarySubPriceRow key={d.name} label={`${d.name} 適用`} price={-d.discount} unit="円" />
              )
            );
          })}
          {installments > 1 && <SummarySubPriceRow label={'お支払い回数'} price={installments} unit={'回'} />}
          {installments > 1 && <SummarySubPriceRow label="分割手数料" price={option.interest} unit={'円'} />}
          <SummarySubPriceRow label="消費税" price={option.tax} unit={'円'} />
          {installments > 1 && <SummarySubPriceRow label="分割支払い金合計" price={option.total_price} unit={'円'} />}
          <SummarySplitter />
          <SummaryPriceRow
            label={installments > 1 ? '初回お支払い' : '合計'}
            price={option.monthly_payments[0]}
            unit="円（税込）"
          />
        </SummaryBody>
      </div>
    );
  }
}
